/** RGB 单通道上限 */
export const RGB_CHANNEL_MAX = 255
/** hex 颜色的有效位数（不含 #） */
export const HEX_DIGIT_LENGTH = 6

/**
 * RGB 通道输入清洗：只保留数字并压到 0-255。
 * 允许中间态为空串，便于清空后重新输入，提交时再兜底为 0。
 */
export function sanitizeRgbChannel(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 3)
  if (digits === '') return ''

  return String(Math.min(Number(digits), RGB_CHANNEL_MAX))
}

/**
 * hex 输入清洗：强制 # 开头，且最多 6 位十六进制字符。
 */
export function sanitizeHex(raw: string): string {
  const digits = raw.replace(/[^0-9a-fA-F]/g, '').slice(0, HEX_DIGIT_LENGTH)
  return `#${digits}`
}

/**
 * hex 补位：不足 6 位时用 f 补足。
 */
export function padHex(value: string): string {
  const digits = value.replace(/[^0-9a-fA-F]/g, '').slice(0, HEX_DIGIT_LENGTH)
  return `#${digits.padEnd(HEX_DIGIT_LENGTH, 'f')}`
}

/**
 * 输入过程中把输入框里的值纠正为清洗后的结果，并尽量保持光标位置。
 * 清洗结果与绑定值相同时不会触发重渲染，非法字符会残留在 DOM 上，所以这里直接改写元素。
 */
export function syncInputElement(event: Event, sanitize: (raw: string) => string) {
  // 输入法组合期间不改写，避免打断候选词
  if ((event as InputEvent).isComposing) return

  const el = event.target as HTMLInputElement
  const sanitized = sanitize(el.value)
  if (el.value === sanitized) return

  const caret = el.selectionStart ?? el.value.length
  const removed = el.value.length - sanitized.length

  el.value = sanitized

  const nextCaret = Math.max(0, Math.min(sanitized.length, caret - removed))
  el.setSelectionRange(nextCaret, nextCaret)
}
